<template>
  <div class="failed-transfer">
    <div>
      <md-icon
        class="icon"
        md-src="/static/images/icon-transfer-fail-large.svg"
      />
    </div>
    <div>
      <p>
        Falha na transferência de <br>
        <span> todas</span> as ordens de serviço!
      </p>
    </div>
    <div>
      <button
        class="btn btn-primary button"
        @click="pushToFailedOrders()"
      >
        VISUALIZAR FALHAS
      </button>
      <button
        class="btn btn-nonenary button"
        @click="pushToOrdersList()"
      >
        VOLTAR PARA LISTAGEM DE OS
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FailedTransfer',
  props: {
    pushToOrdersList: Function,
    pushToFailedOrders: Function
  }
}
</script>


<style lang="scss">
  .failed-transfer {
    text-align: center;

    .icon {
      width: 61px;
      height: 61px;
    }
    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 18px;
      text-align: center;
      color: #617173;
      font-weight: 400;
      padding-top: 23px;
      padding-bottom: 17px;
      span {
        font-weight: bold;
        color: #b40607;
      }
    }
    .button {
      width: 100%;
      margin-top: 10px;
      font-family: Roboto, sans-serif;
      border-radius: 3px;
      font-weight: 500;
      letter-spacing: 0.4px;
    }
  }
</style>

